import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtual from '../../actions/rota-itinerario/determinarPaginaAtualRotaItinerario'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoDisponiveisInternet extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtual}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualRotaItinerario,
    total: state.rotasItinerario.total,
    registrosPorPagina: state.registrosPorPaginaRotaItinerario
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtual }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoDisponiveisInternet)
